import Vue from 'vue'
import VueRouter from 'vue-router'
import Visits from '../views/visits/Visits.vue'
import Login from '../views/login/Login.vue'
import Docks from '../views/docks/Docks.vue'
import Arrivals from '../views/arrivals/Arrivals.vue'
import Booking from '../views/booking/Booking.vue'
import Settings from '../views/Settings.vue'
import Accounts from '../views/settings/accounts/Accounts.vue'
import Account from '../views/settings/account/Account.vue'
import Customers from '../views/settings/customers/Customers.vue'
import Customer from '../views/settings/customer/Customer.vue'
import Regions from '../views/settings/regions/Regions.vue'
import Region from '../views/settings/region/Region.vue'
import Locations from '../views/settings/locations/Locations.vue'
import Location from '../views/settings/location/Location.vue'
import Groups from '../views/settings/groups/Groups.vue'
import Group from '../views/settings/group/Group.vue'
import Entity from '../views/settings/entity/Entity.vue'
import BookingOptions from '../views/settings/booking-options/BookingOptions'
import BookingOption from '../views/settings/booking-option/BookingOption'
import { TokenService } from '../services/token.service'
import { KeycloakService } from '../services/keycloak.service'
import { Constants } from '../constants'
import VisitsTable from "@/views/visits-table/VisitsTable.vue";

Vue.use(VueRouter)

const BASE_TITLE = 'PASS on Point'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      public: true,
      showWhenLoggedOut: true,
      title: `${BASE_TITLE} - Authentication`
    }
  },
  {
    path: '/visits',
    alias: '/visits',
    name: 'Visits',
    component: Visits,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Visits`
    }
  },
  {
    path: '/',
    alias: '/visits-table',
    name: 'VisitsTable',
    component: VisitsTable,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Visits`
    }
  },
  {
    path: '/docks',
    name: 'Docks',
    component: Docks,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Spots`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_PLANNER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/arrivals',
    name: 'Arrivals',
    component: Arrivals,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Arrivals`
    }
  },
  {
    path: '/booking',
    name: 'NewBooking',
    component: Booking,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Book a visit`
    }
  },
  {
    path: '/booking/:id',
    name: 'EditBooking',
    component: Booking,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Edit a visit`
    }
  },
  {
    path: '/settings',
    component: Settings,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/accounts',
    name: 'Accounts',
    component: Accounts,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Accounts`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/accounts/:id',
    name: 'Account',
    component: Account,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Account Details`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Customers`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/customers/:id',
    name: 'Customer',
    component: Customer,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Customer Details`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/regions',
    name: 'Regions',
    component: Regions,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Regions`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/regions/:id',
    name: 'Region',
    component: Region,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Region Details`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/locations',
    name: 'Locations',
    component: Locations,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Locations`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/locations/:id',
    name: 'Location',
    component: Location,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Location Details`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/groups',
    name: 'Groups',
    component: Groups,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Groups`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/groups/:id',
    name: 'Group',
    component: Group,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Group Details`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/groups/group/entity',
    name: 'Entity',
    component: Entity,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - add Entity`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/options',
    name: 'Options',
    component: BookingOptions,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Options`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '/settings/options/:locationId/:id',
    name: 'Option',
    component: BookingOption,
    meta: {
      public: false,
      showWhenLoggedOut: false,
      title: `${BASE_TITLE} - Booking option`,
      authorized: [Constants.ROLE_SUPER_USER, Constants.ROLE_WAREHOUSE_MANAGEMENT]
    }
  },
  {
    path: '*',
    component: VisitsTable
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

    const isPublic = to.matched.some((record) => record.meta.public)
    const showWhenLoggedOut = to.matched.some(
        (record) => record.meta.showWhenLoggedOut
    );
    const isLoggedIn = !!TokenService.getToken()
    const isAuthorized = KeycloakService.isAuthorized(to.meta.authorized)

    if (!isAuthorized) {
        return next('/')
    }

    if (!isPublic && !isLoggedIn) {
        return next({
        path: '/login',
        query: { redirect: to.fullPath },
        });
    }

    if (isLoggedIn && showWhenLoggedOut) {
        return next('/')
    }

    next()
});

export default router
